import React, {Fragment, memo, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Collapse from 'react-bootstrap/lib/Collapse';
import {Card, CardBody} from 'components/card';
import SubCategories from 'cms/faqs/FaqLayout/SubCategories';

const displayCategories = 10;
const toggleSideBar = () => {
  if (document.body.classList.contains('show-sidebar')) {
    document.body.classList.remove('show-sidebar');
  } else {
    document.body.classList.add('show-sidebar');
  }
};

const Sidebar = ({label, moreText, categories}) => {
  const [showMore, setShowMore] = useState(false);
  const toggleMore = () => setShowMore((showMore) => !showMore);

  return (
    <div id="sidebar" className="grid-item-lg-3-10">
      <div id="sidebarButton" onClick={toggleSideBar}>
        <div>{label}</div>
        <i className="icon icon-up-arrow icon-lg" aria-hidden="true" />
      </div>
      <div className="font-bold mb-2 bg-linear d-none d-lg-block">
        <span className="pr-2 bg-light-light">{label}</span>
      </div>
      <Card>
        <CardBody className="p-2" >
          {
            categories.map(({ID, post_title, permanlink, subCategories = [], selected}) => {
              const categoryClass = classNames('text-dark pl-3', {
                'line-selected': selected
              });

              return (
                <Fragment key={ID}>
                  <div className="mx-2 my-3 font-bold position-relative text-truncate">
                    <a className={categoryClass} href={permanlink} title={post_title}>{post_title}</a>
                  </div>
                  {
                    subCategories.length > 0 && 
                      <div className="ml-3 text-small">
                        <SubCategories
                          categories={subCategories}
                          min={0}
                          max={displayCategories}
                        />
                        <Collapse in={showMore}>
                          <div>
                            <SubCategories
                              categories={subCategories}
                              min={displayCategories}
                              max={subCategories.length}
                            />
                          </div>
                        </Collapse>
                        {
                          subCategories.length > displayCategories &&
                            <a onClick={toggleMore}>
                              <span className="mr-1">{moreText}</span>
                              <i className={`icon insidebar ${showMore ? 'icon-up-arrow' : 'icon-down-arrow'}`} />
                            </a>
                        }
                      </div>
                  }
                </Fragment>
              );
            })
          }
        </CardBody>
      </Card>
    </div>
  );
};

Sidebar.propTypes = {
  label: PropTypes.string.isRequired,
  moreText: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired
};

Sidebar.defaultProps = {
  moreText: ''
};

export default memo(Sidebar);
